import { emptyObj } from '@beef/utils';
import { createSelector } from '@reduxjs/toolkit';
import { getCheckAddressConnected } from "../../checkAddress/selectors";
import { mapDropdownOptions } from "../../common/utils";
import { selectIsCheckboxChecked } from "../../CheckboxAgreement/selectors";
import { getModulesData } from "../../selectors";
import { ADDRESS_BLOCK_VIEW_STATUSES, AVAILABLE_STEPS, AVAILABLE_STEPS_FOR_PHONE_INPUT } from "./constants";
export var getAddressCheckModuleData = function getAddressCheckModuleData(state) {
  return getModulesData(state).addressCheck || emptyObj;
};
export var getViewStatus = createSelector([getAddressCheckModuleData], function (addressData) {
  return addressData.status;
});
export var isCheckAddressStep = createSelector([getViewStatus], function (status) {
  return status === ADDRESS_BLOCK_VIEW_STATUSES.checkAddress;
});
export var showPhoneInputFlag = createSelector([getViewStatus], function (status) {
  return AVAILABLE_STEPS_FOR_PHONE_INPUT.includes(status);
});
export var selectDropdownOptions = createSelector([getAddressCheckModuleData], function (_ref) {
  var addressSuggestions = _ref.addressSuggestions;
  return mapDropdownOptions(addressSuggestions);
});
export var selectAddressInputErrorStatus = createSelector([getAddressCheckModuleData], function (_ref2) {
  var isAddressError = _ref2.isAddressError;
  return isAddressError;
});
export var getSelectedAddress = createSelector([getAddressCheckModuleData], function (_ref3) {
  var selectedAddress = _ref3.selectedAddress;
  return selectedAddress;
});
export var selectIsLoadingFlag = createSelector([getAddressCheckModuleData], function (_ref4) {
  var isLoading = _ref4.isLoading;
  return isLoading;
});
// TODO: после миграции на метод проверки адреса в одно поле удалить селектор
export var selectFiasAddress = createSelector([getSelectedAddress], function (address) {
  return address === null || address === void 0 ? void 0 : address.value;
});

// TODO: после миграции на метод проверки адреса в одно поле удалить селектор
export var selectShowNotificationFlag = createSelector([getCheckAddressConnected, getViewStatus], function (statusFromMap, status) {
  return statusFromMap || AVAILABLE_STEPS.includes(status);
});
export var selectIsCheckboxError = createSelector([getAddressCheckModuleData, selectIsCheckboxChecked], function (_ref5, isCheckboxChecked) {
  var isCheckboxError = _ref5.isCheckboxError;
  return isCheckboxError && !isCheckboxChecked;
});